import make, { Enum } from '@xaamin/enum';

class ExcelFileStatus extends Enum {

  name = 'ExcelFileStatus';

  enum = {
    'pending': 0,
    'error': -2,
    'completed': 1,
    'uploading': 2,
    'uploaded': 3,
    'processing': 4,
    'queued': 5,
    'processed': 6,
    'stamping': 7,
  }

}

export default make(ExcelFileStatus);